import(/* webpackMode: "eager" */ "/var/www/labradorpuppies_v2/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/labradorpuppies_v2/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/var/www/labradorpuppies_v2/src/app/home-landing/components/HomeLandingInteractive.tsx");
